import React from 'react'
import AddressSearchDialogContent from '../../routes/address/AddressSearchDialogContent'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import AddressHeaderForm from '../address/AddressHeaderForm'
import Page from '../genericComponents/Page'
import Header from '../header/Header'
import Main from '../main/Main'
import Map from '../map/Map'
import PushNotificationPopup from '../PushNotification/PushNotificationPopup'
import SearchDialog from '../search/SearchDialog'
import AddressSuggestContent from '../suggest/AddressSuggestContent'
import SeoZoneMapImage from './zones/SeoZoneMapImage'
import SeoZoneMetaManager from './zones/SeoZoneMetaManager'
import { CountryTitle } from './zones/ZoneContent'
import ZoneMainContent from './zones/ZoneMainContent'

export const renderPage = () => {
  const { AddressPage, withToaster } = PAGE_CLASSES

  return (
    <Page cssClasses={[AddressPage, withToaster]} key="Page">
      <SeoZoneMetaManager />
      <Map key="Map" staticMap={<SeoZoneMapImage />} />
      <Header key="Header" transparent>
        <AddressHeaderForm key="AddressHeaderForm" transparent />
      </Header>
      <SearchDialog key="SearchDialog" suggestContent={<AddressSuggestContent />}>
        <AddressSearchDialogContent />
      </SearchDialog>
      <PushNotificationPopup />
      <Main key="Main" withoutSubHeader>
        <ZoneMainContent titleContent={<CountryTitle />} />
      </Main>
    </Page>
  )
}
